export default "__VITE_ASSET__Bmg_Ji_l__"